import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=9a1a494a&scoped=true&lang=pug&"
import script from "./CategoryProducts.vue?vue&type=script&lang=js&"
export * from "./CategoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProducts.vue?vue&type=style&index=0&id=9a1a494a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1a494a",
  null
  
)

/* custom blocks */
import block0 from "./CategoryProducts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports